import AuthService from 'shared/js/lib/authService';

// singleton auth service
export default new AuthService({
  connection: 'FleetUsers'
});
export const callbackURL = AuthService.callbackURL;